import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getCustomerReport } from "../../../actions/invoiceItem";
import { getAllLocationPlain } from "../../../actions/warehouseAction";
import ReactToPrint from "react-to-print";
import dateFormat from "dateformat";
import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Select,
  Button,
  Layout,
  DatePicker,
  Spin,
  Breadcrumb,
  InputNumber,
} from "antd";

const { RangePicker } = DatePicker;
const { Content } = Layout;
const { Option } = Select;

const CustomerReport = ({
  getCustomerReport,
  getAllLocationPlain,
  businessprofile,
  Auth,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [data, setData] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initial, setInitial] = useState(false);
  const [reload, setReload] = useState(false);
  const location = useRef("");
  const start = useRef("");
  const end = useRef("");
  const keyward = useRef("");
  const minInvoices = useRef(2);
  const flag = useRef(0);
  console.log(data)

  const onChange = (event) => {
    if (event.keyCode === 13) {
      keyward.current = event.target.value;
    }
  };

  useEffect(() => {
    if (flag.current !== 0) {
      getAllLocationPlain().then((res) => {
        setLocations(res);
        getCustomerReport(
          keyward.current,
          start.current,
          end.current,
          location.current,
          minInvoices.current
        ).then((result) => {
          setData(result || []);
          setLoading(false);
        });
      });
    } else {
      setInitial(true);
      getAllLocationPlain().then((res) => {
        setLocations(res);
        setInitial(false);
      });
    }
  }, [reload]);

  const exportToCSV = () => {
    // Create CSV content with header and phone numbers
    const phoneNumbers = data
      .map((item) => item.phone || "")
      .filter((phone) => phone); // Remove empty values
    
    const csvContent = "contacts\n" + phoneNumbers.join("\n");

    // Create blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "Customer_Phone_Numbers.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Report</Breadcrumb.Item>
        <Breadcrumb.Item>Customer Report</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <Row gutter={[16, 16]} wrap={true}>
          <Col span={4}>
            <h3>Search by</h3>
            <AutoComplete
              placeholder="name, phone, email"
              onKeyUp={onChange}
              style={{ width: "100%", minWidth: "130px" }}
            />
          </Col>
          <Col span={6}>
            <h3>Purchase date:</h3>
            <RangePicker
              style={{ width: "100%" }}
              picker="date"
              onChange={(value) => {
                if (value) {
                  start.current = value[0].format("YYYY-MM-DD") + "T00:00:00";
                  end.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
                }
              }}
            />
          </Col>
          <Col span={2}>
            <h3>Minimum</h3>
            <InputNumber
              min={2}
              defaultValue={2}
              style={{ width: "100%" }}
              onChange={(value) => {
                minInvoices.current = value || 2;
              }}
            />
          </Col>
          <Col span={5}>
            <h3>Warehouse / Outlet</h3>
            <Select
              placeholder="Select outlet"
              style={{ width: "100%" }}
              disabled={
                Auth.superuser ||
                Auth.profile.user_role.id === 10 ||
                Auth.profile.user_role.id === 36 ||
                Auth.profile.user_role.id === 38
                  ? false
                  : true
              }
              onChange={(e) => {
                location.current = e;
              }}
            >
              <Option value="">All</Option>
              {(locations || []).map((outlet) => (
                <Option key={outlet.id} value={outlet.id}>
                  {outlet.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={2}>
            <h3>Quick</h3>
            <Button
              type="primary"
              style={{ width: "100%", backgroundColor: "#ab0735" }}
              onClick={() => {
                flag.current = 1;
                setLoading(true);
                setReload(!reload);
              }}
            >
              Search
            </Button>
          </Col>
          <Col span={2}>
            <h3>Download</h3>
            <Button
              style={{ width: "100%" }}
              type="primary"
              onClick={exportToCSV}
              disabled={data.length === 0}
            >
              CSV
            </Button>
          </Col>
          <Col span={2}>
            <h3>Download</h3>
            <ReactToPrint
              trigger={() => (
                <Button style={{ width: "100%" }} type="primary">
                  PDF
                </Button>
              )}
              content={() => componentRef.current}
            />
          </Col>
        </Row>
        <Divider />
        <Spin spinning={loading}>
          <div ref={componentRef} style={{ padding: "10px" }}>
            <h2 style={{ textAlign: "center" }}>Customer Report</h2>
            <h4 style={{ textAlign: "center" }}>
              (Customers with {minInvoices.current}+ Invoices)
            </h4>
            <Row>
              <Col span={12} style={{ textAlign: "left" }}>
                {start.current !== "" && (
                  <>
                    From: {dateFormat(start.current, "mmmm dS, yyyy")}
                    <br />
                  </>
                )}
                {end.current !== "" && (
                  <>
                    To: {dateFormat(end.current, "mmmm dS, yyyy")}
                    <br />
                  </>
                )}
              </Col>
              <Col span={12} style={{ textAlign: "right" }}>
                {locations.map((outlet) => {
                  if (outlet.id === location.current)
                    return <span key={outlet.id}>Outlet: {outlet.name}</span>;
                  return null;
                })}
              </Col>
            </Row>
            <br />
            <table
              className="attendacne_table"
              style={{ width: "100%", textAlign: "center" }}
            >
              <thead>
                <tr style={{ background: "#FAFAFA" }}>
                  <th>SL.</th>
                  <th>Phone</th>
                  <th>Customer Name</th>
                  {/* <th>Address</th> */}
                  <th>Invoices</th>
                  <th>Bill</th>
                  {/* <th>Paid</th>
                  <th>Due</th>
                  <th>Discount</th> */}
                  <th>Last Purchase</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.phone || "N/A"}</td>
                    <td style={{ textAlign: "center" }}>{item.name || "N/A"}</td>
                    {/* <td>{item.address || "N/A"}</td> */}
                    <td>{item.total_invoices || 0}</td>
                    <td>{formatter.format(item.total_amount || 0)}</td>
                    {/* <td>{formatter.format(item.total_paid || 0)}</td>
                    <td>{formatter.format(item.total_due || 0)}</td>
                    <td>{formatter.format(item.total_discount || 0)}</td> */}
                    <td>
                      {item.last_purchase_date
                        ? dateFormat(item.last_purchase_date, "dd-mm-yyyy")
                        : "N/A"}
                    </td>
                  </tr>
                ))}
                {data.length === 0 && (
                  <tr>
                    <td colSpan="10" style={{ textAlign: "center" }}>
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
              {data.length > 0 && (
                <tfoot>
                  <tr style={{ background: "#FAFAFA", fontWeight: "bold" }}>
                    <td colSpan="3" style={{ textAlign: "center" }}>
                      Total:
                    </td>
                    <td>
                      {data.reduce(
                        (sum, item) => sum + (item.total_invoices || 0),
                        0
                      )}
                    </td>
                    <td>
                      {formatter.format(
                        data.reduce(
                          (sum, item) => sum + parseFloat(item.total_amount || 0),
                          0
                        )
                      )}
                    </td>
                    {/* <td>
                      {formatter.format(
                        data.reduce(
                          (sum, item) => sum + parseFloat(item.total_paid || 0),
                          0
                        )
                      )}
                    </td>
                    <td>
                      {formatter.format(
                        data.reduce(
                          (sum, item) => sum + parseFloat(item.total_due || 0),
                          0
                        )
                      )}
                    </td>
                    <td>
                      {formatter.format(
                        data.reduce(
                          (sum, item) =>
                            sum + parseFloat(item.total_discount || 0),
                          0
                        )
                      )}
                    </td> */}
                    <td></td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </Spin>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getCustomerReport,
  getAllLocationPlain,
})(CustomerReport);